import format from "date-fns/format";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/Modal";
import { Spacer } from "@/components/common";
import { TaskComment } from "@/models/tasks";

type Props = {
  comments: TaskComment[];
  itemName: string;
  processName: string;
  onClose: () => void;
};

export const CommentListModal = ({ comments, itemName, processName, onClose }: Props) => {
  const { t } = useTranslation();

  const taskComments = useMemo<{ text: string; updateAt: string; updateBy: string }[]>(() => {
    return comments.map((comment) => ({
      text: comment.comment,
      updateAt: comment.timestamp?.update_date ? format(new Date(comment.timestamp.update_date), "yyyy/MM/dd") : "",
      updateBy: comment.user_name,
    }));
  }, [comments]);

  return (
    <Modal title={t("comment_list")} closeHandler={onClose}>
      <div className="modal-body w-[440px]">
        <p className="text-center">
          {itemName}：{processName}
        </p>
        <Spacer y="15px" />
        <ul className="flex flex-col gap-[5px]">
          {taskComments.map((comment, index) => (
            <li key={index} className="bg-white p-[10px] border-[1px] border-[#cccccc]">
              <p>{comment.text}</p>
              <Spacer y="4px" />
              <div className="flex gap-[1rem] text-[#969696]">
                <span>{comment.updateAt}</span>
                <span>{comment.updateBy}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="modal-footer">
        <button data-test-id="button-comment-editor-close" type="button" className="btn btn-blue" onClick={onClose}>
          {t("close")}
        </button>
      </div>
    </Modal>
  );
};
